import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ButtonCustom from '../../../../../Components/ButtonCustom'
import { Inline } from '../../../../../Components/CustomUi/inline'
import Input from '../../../../../Components/CustomUi/input'
import { removerAcentos } from '../../../../../utils'
import { faArrowsToEye, faEdit, faMapLocationDot, faPlus } from '@fortawesome/free-solid-svg-icons'
import { Box } from '../../../../../Components/CustomUi/box'
import GeneratePdfButton from '../../../../../Components/relatorio-component'
import { HeaderTable } from '../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../Components/CustomUi/table/rowItem'
import { DeleteButton } from '../../../../../Components/CustomUi/deleteButton'
import { Empty } from 'antd'
import Carregando from '../../../../../Components/CustomUi/loading'
import { ItensPerUserLogged } from '../../../../../services/login/permissaoUsuarioLoado'
import { Select } from '../../../../../Components/CustomUi/Select'
import { SetStateAction, useState } from 'react'
import Icon from '@ant-design/icons'
import Svg from '../../../../../Components/talhasvg'
import secureLocalStorage from 'react-secure-storage'

interface Props {
  loading: boolean
  list_subareas: any[]
  deletar: Function
  abrir?: Function
  editar: Function
  selecionar_propriedade: string
  setSelecionar_propriedade: React.Dispatch<React.SetStateAction<string>>
  selecionar_propriedade_id: number
  setSelecionar_propriedade_id: React.Dispatch<React.SetStateAction<number>>
  permissao: ItensPerUserLogged
  setPagination?: React.Dispatch<React.SetStateAction<number>>
  page?: number
  setPage?: React.Dispatch<React.SetStateAction<number>>
  total: number
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: number
  setId_item_atual: React.Dispatch<React.SetStateAction<number>>
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  buscarTabela: string
  setBuscarTabela: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  lista_propriedades: any[]
  dadosEstatisticas: any[]
  dadosResultado: any[]
}

export const TabelaSubArea: React.FC<Props> = ({
  list_subareas,
  loading,
  deletar,
  abrir,
  setPagination,
  editar,
  page,
  setPage,
  total,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  setNome_item_atual,
  buscarTabela,
  setBuscarTabela,
  fake_loading,
  selecionar_propriedade,
  setSelecionar_propriedade,
  setSelecionar_propriedade_id,
  lista_propriedades,
  dadosEstatisticas,
  dadosResultado,
}) => {
  function buscarFornecedores(buscar_nome: string) {
    const palavraSemAcentos = removerAcentos(buscar_nome)
    return function (item) {
      const nomeSemAcentos = removerAcentos(String(item?.nome))

      return (
        nomeSemAcentos.toLowerCase().includes(palavraSemAcentos.toLowerCase()) ||
        !buscar_nome
      )
    }
  }

  const [openSelect, setOpenSelect] = useState<boolean>(false)

  return (
    <div style={{ height: 'calc(100vh - 170px)' }}>
      <Inline justifyContent='center'>
        <Select
          value={selecionar_propriedade}
          onChange={setSelecionar_propriedade}
          onChangeID={setSelecionar_propriedade_id}
          placeholder='Selecione uma propriedade'
          open={openSelect}
          trigger={setOpenSelect}
          items={lista_propriedades}
          descricaoItem={'nome'}
          idItem={'cod'}
          icon={faMapLocationDot}
          width={'50%'}
        />
        <Input placeholder='Buscar propriedades' value={buscarTabela} onChange={setBuscarTabela} />
        <Inline alignItems='center' style={{ height: '45px' }}>
          {secureLocalStorage.getItem('tipo-acesso') === 'conta' ? (
            <GeneratePdfButton
              dados={dadosEstatisticas}
              title={'Relatório propriedade'}
              totais={dadosResultado}
              disable={list_subareas.length <= 0}
            />
          ) : null}
        </Inline>
      </Inline>
      <HeaderTable
        itens={[
          { valor: 'Talhão', width: '75px' },
          { valor: 'Nome', width: 'calc(100% - 435px)' },
          { valor: 'Qtde Subárea', width: '140px' },
          { valor: 'Área/ha', width: '95px' },
          { valor: 'Ações', width: '100px' },
        ]}
      />

      <BodyTable
        paginate={total}
        onChangeItensPage={setPagination}
        onChangePage={setPage}
        current_page={page}
        setCurrent_page={setPage}
        style={{
          height: (list_subareas ?? []).length < 8 && 'calc(100vh - 170px)',
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'scroll',
          marginTop: -10,
        }}
      >
        <Render condition={!loading}>
          {(list_subareas ?? [])
            .filter(buscarFornecedores(buscarTabela))
            .map(({ cod, nome, area, kml, sub_area }) => {
              return (
                <RowTable
                  key={cod}
                  onDoubleClick={() => editar(cod, false)}
                  style={{ height: 'auto' }}
                >
                  <RowItem width={'75px'} style={{ marginTop: '5px' }}>
                    {
                      <Icon
                        component={() => (
                          <Svg fill='green' fillOpacity={0.5} coordinates={kml?.coordenadas} />
                        )}
                      />
                    }
                  </RowItem>
                  <RowItem fontSize={13} width={'calc(100% - 429px)'}>
                    {nome}
                  </RowItem>
                  <RowItem fontSize={13} width={'140px'}>
                    {sub_area.length}
                  </RowItem>
                  <RowItem fontSize={13} width={'95px'}>
                    {area} ha
                  </RowItem>
                  <RowItem width={'100px'}>
                    <ButtonCustom
                      icon={<FontAwesomeIcon icon={faEdit} />}
                      onClick={() => {
                        editar(cod, false)
                      }}
                    >
                      Editar
                    </ButtonCustom>
                  </RowItem>
                </RowTable>
              )
            })}
        </Render>

        <Render condition={list_subareas.length === 0 && !loading}>
          {buscarTabela === '' ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={<> Nenhum registro disponível!</>}
            />
          ) : (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={
                <>
                  {' '}
                  <b>'{buscarTabela}'</b> não encontrado!
                </>
              }
            />
          )}
        </Render>

        <Render condition={loading}>
          <Carregando
            animation
            legenda='Carregando subáreas...'
            justifyContent='center'
            height={400}
            size='default'
          />
        </Render>
      </BodyTable>
    </div>
  )
}
